import { module } from 'stereomodularjs';
import { CalendarPermissionScope, CapacitorCalendar } from '@ebarooni/capacitor-calendar';

export default class extends module {
    constructor(m) {
        super(m);
        this.dialog = document.querySelector(".js-modal");
        this.showButton = this.el;
        this.closeButton = document.querySelectorAll(".js-modal-close");
        this.modalContent = document.querySelectorAll('[data-modal="content"]');
        this.overlayPanel = document.querySelector(this.el.getAttribute('data-modal'));
        this.overlayVideo = document.querySelector('.js-modal-video');

        this.date = null;
        this.titre = null;
    }

    init() {
        // "Show the dialog" button opens the dialog modally
        this.showButton.addEventListener("click", () => {
            // Hide all other modals items
            this.modalContent.forEach(content => {
                content.classList.remove('is-active');
            });
            // Show the current modal item
            this.overlayPanel.classList.add('is-active');
            // Set video content
            if (this.el.getAttribute('data-video')) {
                let overlayVideo = this.el.getAttribute('data-video');
                this.overlayVideo.innerHTML = overlayVideo;
            }


            if (this.el.getAttribute('data-modal') == '.js-modal-content-rappel') {
                let date = document.querySelector('input[name="Date"]');
                let titre = document.querySelector('input[name="RappelTitre"]');

                this.dialog.querySelector('[data-date]').innerHTML = date.value;
                this.dialog.querySelector('[data-titre]').innerHTML = titre.value;
            }
            
            this.dialog.showModal();
            
        });

        // "Close" button closes the dialog
        this.closeButton.forEach(close => {
            close.addEventListener("click", this.closeDialog.bind(this));
        });

        // Clicking the backdrop closes the dialog
        this.dialog.addEventListener("click", (event) => {
            if (event.target === this.dialog) {
                this.closeDialog();
            }
        });

    }

    closeDialog(event) {
        if (event) {
            event.stopPropagation();
        }

        this.dialog.setAttribute("closing", "");

        this.dialog.addEventListener(
            "animationend",
            () => {
                this.dialog.removeAttribute("closing");
                this.dialog.close();
                this.overlayVideo.innerHTML = '';

                // Remove event listeners from close buttons
                this.closeButton.forEach(close => {
                    close.removeEventListener("click", this.closeDialog.bind(this));
                });
            },
            { once: true }
        );
    }
}
